import { queryOptions } from '@tanstack/react-query'

import { apiClient } from '.'

export async function fetchFoodRestrictions() {
  return apiClient.get('/food-restrictions/').then((res) => res.data)
}

export const foodRestrictionsQuery = queryOptions({
  queryKey: ['food-restrictions'],
  queryFn: () => fetchFoodRestrictions(),
})

export async function getFoodRestriction(idFoodRestriction: number) {
  return apiClient.get(`food-restrictions/${idFoodRestriction}`).then((res) => res.data)
}

export async function deleteFoodRestriction(idFoodRestriction: number) {
  return apiClient.delete(`/food-restrictions/${idFoodRestriction}`).then((res) => res.data)
}

export async function createOrUpdateFoodRestriction(foodRestriction: any) {
  return apiClient.post('/food-restrictions/', foodRestriction).then((res) => res.data)
}
